import { Injectable } from "@angular/core";
import { Subject, firstValueFrom, tap, throttleTime } from "rxjs";
import { QQQuestionViewModel } from "../models/qq-question.view-model";
import { QQQuestionnairePageViewModel } from "../models/qq-questionnaire-page.view-model";
import { QQQuestionnaireViewModel } from "../models/qq-questionnaire.view-model";
import { AnalyticsService } from "./analytics.service";
import { ApiService } from "./api.service";

@Injectable({
    providedIn: 'root'
})
export class QuestionnaireService {

    private saveQueue$ = new Subject<QQQuestionnaireViewModel>();

    constructor(
        private api: ApiService,
        private analyticsService: AnalyticsService) {

        this.saveQueue$.pipe(
            throttleTime(1000, null, { leading: true, trailing: true }),
            tap(x => this.saveQuestionnaire(x))
        ).subscribe();
    }

    async getQuestionnaireViewModel(name: string, saveAnswers: boolean, answers?: any, quoteKey?:string) {
        let q = await this.api.getQuestionnaire(name);
        const model = new QQQuestionnaireViewModel(q, this.api, answers, quoteKey);
        model.currentPage$.pipe(
            tap(x => this.onCurrentPageChanged(model, x, saveAnswers))
        ).subscribe();

        return model;
    }

    onCurrentPageChanged(model: QQQuestionnaireViewModel, page: QQQuestionnairePageViewModel, saveAnswers: boolean) {
        this.analyticsService.logPageView(`${model.name}/${page.title}`, { page_title: `${model.name} | ${page.title}` });
        page.onQuestionAnswered.pipe(
            tap(x => this.onQuestionAnswered(`${model.name}/${page.title}`, x.question, x.answer)),
            tap(x => {
                if (saveAnswers) {
                    this.saveQueue$.next(model);
                }
            })
        ).subscribe();
    }

    onQuestionAnswered(quotePage: string, question: QQQuestionViewModel, answer: string) {
        if (!answer)
            this.analyticsService.logEvent('question_skipped', { quote_page: quotePage, question: question.key });
        else
            this.analyticsService.logEvent('question_answered', { quote_page: quotePage, question: question.key });
    }


    private async saveQuestionnaire(questionnaire: QQQuestionnaireViewModel) {
        try {
            const hasAnswers = [...questionnaire.answers.values()].filter(x => !!x).length > 0;
            if (!hasAnswers)
                return;

            if (questionnaire.saving)
                await questionnaire.saving;

            questionnaire.saving = new Promise(async (resolve) => {
                const rsp = await this.api.saveQuestionnaire(questionnaire.name,
                    questionnaire.quoteKey,
                    [...questionnaire.answers].map(([key, value]) => ({ Key: key, Value: value })),
                    questionnaire.sourceUrl
                );

                if (rsp.key)
                    questionnaire.quoteKey = rsp.key;

                resolve();
            });

        } catch (e) {
            console.log('Error saving questionnaire: %o', e);
        }
    }
}